export const getSocialButtonsConfig = state => state.config.socialButtonsConfig



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/config/config.selectors.js